<script>
    import { getContext } from "svelte";
    import { createForm } from "svelte-forms-lib";
    import axios from "axios";

    import * as yup from "yup";
    import { token, user } from "../../store";
    
    import { useQuery, useMutation  } from '@sveltestack/svelte-query';
    const profilData = useQuery("profilData");

    import {
        FormGroup,
        Label,
        Input,
        Spinner
    } from 'sveltestrap';
    import Swal from 'sweetalert2';

    import { _ } from "svelte-i18n";

    let today  = new Date;
    let todayMonth = today.getMonth() + 1;
    let todayDay = today.getUTCDate();

    if(todayMonth < 10)
        todayMonth = "0" + todayMonth;

    if (todayDay < 10)
        todayDay = "0" + todayDay;

    let todayFormat = "-" + todayMonth + "-" + todayDay;

    let eighteenYearsAgo = today.getFullYear()-18  + todayFormat;
    let ninetynineYearsAgo = today.getFullYear()-99 + todayFormat;

    let apiUrl = getContext("apiUrl");
    let postURL = apiUrl + 'ProfilUpdateNameDescAge.php?token=' + $token;

    let result;

    let mutation = useMutation(val => axios.post(postURL, val), {
        onSuccess: (data, variables) => {
            result = data.data

            const Toast = Swal.mixin({
                toast: true,
                position: 'top-right',
                iconColor: 'white',
                customClass: {
                popup: 'colored-toast'
                },
                showConfirmButton: false,
                timer: 2500,
                timerProgressBar: true
            })

            if(result.success){
                $user.name = variables.name
                window.navigator.vibrate(200);
                Toast.fire({
                    icon: 'success',
                    title: result.success
                })
            }

            if(result.error){
                Toast.fire({
                    icon: 'error',
                    title: result.error
                })
            }
        }
   });

    const { form, errors, handleChange, isSubmitting, handleSubmit, isValid } = createForm({
        initialValues: {
            name: $profilData.data.name,
            birthDate: $profilData.data.birthDate,
            description: $profilData.data.description
        },
        validationSchema: yup.object().shape({
            name: yup
                .string($_("components.Forms.errorMessage.string"))
                .min(3, $_("components.Forms.errorMessage.min", { min:"3" }))
                .max(20, $_("components.Forms.errorMessage.max", { max:"20" }))
                .required($_("components.Forms.errorMessage.required")),
            birthDate: yup
                .date()
                .min(ninetynineYearsAgo, $_("components.Forms.errorMessage.dateMin"))
                .max(eighteenYearsAgo, $_("components.Forms.errorMessage.dateMax")),
            description: yup
                .string()
                .notRequired()
        }),
        onSubmit: async values => {
            
            /*
            result = axios.post(postURL, values).then(function (response){
                    return response.data
            })*/

            return $mutation.mutate(values)
        },
    });
</script>

<form on:submit|preventDefault={handleSubmit} id="ProfilUpdate1" class="needs-validation" novalidate>   
    <FormGroup>
        <Label for="name">Prénom :</Label>
        {#if $errors.name}
            <Input 
                name="name" 
                id="name"
                type="text"
                bind:value={$form.name}
                on:change={handleChange}
                on:blur={handleChange}
                minlength="3"
                maxlength="20"
                autocomplete="given-name"
                invalid
                feedback={$errors.name}
                required
            />
        {:else}
            <Input 
                name="name" 
                id="name"
                type="text"
                bind:value={$form.name}
                on:change={handleChange}
                on:blur={handleChange}
                minlength="3"
                maxlength="20"
                autocomplete="given-name"
                required
            />
        {/if}
    </FormGroup>
    <FormGroup>
        <Label for="birthDate">Birthdate :</Label>
        {#if $errors.birthDate}
            <Input 
                type="date"
                name="birthDate"
                id="birthDate"
                bind:value={$form.birthDate}
                on:change={handleChange}
                on:blur={handleChange}
                min="{ninetynineYearsAgo}"
                max="{eighteenYearsAgo}"
                autocomplete="bday"
                invalid
                feedback={$errors.birthDate}
                required
            />
        {:else}
            <Input 
                type="date"
                name="birthDate"
                id="birthDate"
                bind:value={$form.birthDate}
                on:change={handleChange}
                on:blur={handleChange}
                min="{ninetynineYearsAgo}"
                max="{eighteenYearsAgo}"
                autocomplete="bday"
                required
            />
        {/if}
    </FormGroup>
    <FormGroup>
        <Label for="description">Description :</Label>
        <textarea class="form-control" name="description" cols="30" rows="6" maxlength="250" 
        bind:value={$form.description}
        on:change={handleChange}
        on:blur={handleChange}></textarea>
    </FormGroup>
    <FormGroup class="text-end">
        {#if $isSubmitting}
            <Spinner /> {$_("components.Forms.LoginForm.loading")}...
        {:else}
            <input type="submit" class="btn btn-outline-secondary" value="Modifier" disabled={!$isValid}/>
        {/if}
    </FormGroup>
</form>